<script lang="ts">
    import type { NodeViewProps } from '@tiptap/core';
    import { onMount } from 'svelte';
    import { NodeViewWrapper } from 'svelte-tiptap';
    import { twMerge } from 'tailwind-merge';

    export let node: NodeViewProps['node'];
    export let selected: NodeViewProps['selected'];
    export let editor: NodeViewProps['editor'];
    export let getPos: NodeViewProps['getPos'];
    $$restProps;

    let isCursorWithin: boolean;

    const updateCursorWithin = () => {
        const nodePos = getPos();

        const nodeStart = nodePos;
        const nodeEnd = nodePos + node.nodeSize;
        const cursorPos = editor.state.selection.$from.pos;

        isCursorWithin = cursorPos >= nodeStart && cursorPos <= nodeEnd;
    };

    onMount(() => {
        editor.on('selectionUpdate', updateCursorWithin);
        return () => editor.off('selectionUpdate', updateCursorWithin);
    });
</script>

<NodeViewWrapper class={twMerge('rounded bg-green-50', selected && 'selected', isCursorWithin && 'bg-white')}>
    <div class="mb-2 flex flex-col gap-1 p-1">
        <p class="flex items-center gap-1 text-xs font-semibold text-green-600" contenteditable="false">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.1575 7.72208C10.3836 7.17611 10.5 6.59095 10.5 6C10.5 4.80653 10.0259 3.66193 9.18198 2.81802C8.33807 1.97411 7.19347 1.5 6 1.5C4.80653 1.5 3.66193 1.97411 2.81802 2.81802C1.97411 3.66193 1.5 4.80653 1.5 6C1.5 6.59095 1.6164 7.17611 1.84254 7.72208C2.06869 8.26804 2.40016 8.76412 2.81802 9.18198C3.23588 9.59984 3.73196 9.93131 4.27792 10.1575C4.82389 10.3836 5.40905 10.5 6 10.5C6.59095 10.5 7.17611 10.3836 7.72208 10.1575C8.26804 9.93131 8.76412 9.59984 9.18198 9.18198C9.59984 8.76412 9.93131 8.26804 10.1575 7.72208Z"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path d="M6 8.5C7.38071 8.5 8.5 7.38071 8.5 6C8.5 4.61929 7.38071 3.5 6 3.5C4.61929 3.5 3.5 4.61929 3.5 6C3.5 7.38071 4.61929 8.5 6 8.5Z" fill="currentColor" />
            </svg>
            {node.attrs['data-name']}
        </p>
        <div data-node-view-content class="bhsn-slot-reference relative flex min-h-[1.5rem] cursor-text">
            {#if node.content.childCount === 1 && node.content.firstChild?.type.name === 'paragraph' && node.content.firstChild.content.size === 0}
                <span class="pointer-events-none absolute left-0 top-0 text-sm text-gray-500" contenteditable="false">
                    이 영역에 표시될 내용을 입력해주세요. (입력하지 않으면 이 영역은 보여지지 않습니다.)
                </span>
            {/if}
        </div>
    </div>
</NodeViewWrapper>

<style>
    /* 가상 커서 모양 수정 - 세로 커서로 변경 */
    :global(.bhsn-slot-reference .ProseMirror-gapcursor:after) {
        border-top: none !important;
        border-left: 1.2px solid #000 !important;
        height: 1.2rem !important;
        top: 0.12rem !important;
        width: 0 !important;
    }
</style>
